import { useLocation, Location } from 'react-router-dom'
import { IuseRouteResource } from './type'

export const useRouteExtract: () => Location & IuseRouteResource = () => {
  const { pathname, search, ...rest } = useLocation()
  const SearchParams = new URLSearchParams(search)
  const queryParams = {}

  search
    .replace(/[&?]/g, ',')
    .split(',')
    .filter((q) => q)
    .forEach((q) => {
      const key = q.split('=')[0]
      queryParams[key] = SearchParams.get(key) || null
    })

  const pathSegments = pathname.split('/').filter((elem) => elem)

  return {
    pathname,
    search,
    queryParams,
    pathSegments,
    ...rest,
  }
}
